import { useAuthContext } from 'context/AuthContext/AuthContext';
import axios from 'axios';

const createAxios = (token?: string) => {
  const authToken = token ? `Token ${token}` : '';
  const axiosInstance = axios.create();

  axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';
  axiosInstance.defaults.headers.common.Authorization = authToken;
  // axiosInstance.defaults.timeout = 2500;

  return axiosInstance;
};

export default function useApi() {
  const { token } = useAuthContext();
  const api = createAxios(token || undefined);

  return api;
}
